import { isProductionDomain, isSandboxDomain } from "constants/domains";

const isGCXDomain = () => {
  const hostname = window.location.hostname;
  if (!hostname) return false;
  return isProductionDomain(hostname) || isSandboxDomain(hostname);
};

const handleChatWidget = () => {
  window.duet && window.duet.open();
  window.zE && window.zE('messenger', 'open');
}

export { isGCXDomain, handleChatWidget }
